import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-body',
  templateUrl: './hero-body.component.html',
})
/**
 * Hero body according to bulma is container with title and subtitle of the page
 */
export class HeroBodyComponent {
  @Input() title: string;
  @Input() subtitle: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/ui-general/components/hero/hero-body/hero-body.component.ts